/**
 * Text processing utilities for Supernal TTS Widget
 */

/**
 * Scrub text to remove URLs and convert markdown links to plain text
 * - Markdown links [text](url) -> text
 * - Bare URLs -> "link"
 */
export function scrubText(text: string): string {
  if (!text) return '';

  let scrubbed = text;

  // Replace markdown links [text](url) with just the text
  // Handles various URL formats including those with/without http/https
  scrubbed = scrubbed.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1');

  // Replace bare URLs with the word "link"
  // Matches http://, https://, and www. URLs
  scrubbed = scrubbed.replace(/https?:\/\/[^\s]+/g, 'link');
  scrubbed = scrubbed.replace(/www\.[^\s]+/g, 'link');

  return scrubbed;
}

/**
 * Format voice name for display
 */
export function formatVoiceName(voice: string): string {
  // Capitalize first letter and replace dashes/underscores with spaces
  return voice
    .replace(/[-_]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Format seconds to MM:SS
 */
export function formatTime(seconds: number): string {
  if (!seconds || isNaN(seconds)) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}
